import React, {useState} from 'react'
import {Button} from "@mantine/core";
import {IconBallpenOff, IconBallpen} from "@tabler/icons-react"
import {useDispatch, useSelector} from "react-redux";
import {setHighlighted} from "../redux/actions";
import {useTranslation} from "react-i18next";

export default function GridHighlightButton(props) {
    const dispatch = useDispatch()
    const highlightedList = useSelector(state => state.customer.highlightedList)
    const [isHighlighted, setIsHighlighted] = useState(highlightedList.includes(props.data.SerialNumber))
    const { t } = useTranslation();
    const handleClick = () => {
        const highlightedRows = JSON.parse(localStorage.getItem('highlightedList')) || [];
        // Check if the row is already highlighted
        const isHighlighted = highlightedRows.includes(props.data.SerialNumber);

        // Update the list of highlighted rows
        let updatedHighlightedRows;
        if (isHighlighted) {
            // Remove the row from the highlighted list
            updatedHighlightedRows = highlightedRows.filter(id => id !== props.data.SerialNumber);
            setIsHighlighted(false)
        } else {
            // Add the row to the highlighted list
            updatedHighlightedRows = [...highlightedRows, props.data.SerialNumber];
            setIsHighlighted(true)
        }

        // Dispatch the action to set the highlighted rows
        dispatch(setHighlighted(updatedHighlightedRows));

        // Update local storage
        localStorage.setItem('highlightedList', JSON.stringify(updatedHighlightedRows));
    };
    //rightSection={isHighlighted ? (t("Clear")): (t("Highlight"))} //if we want highlight help text, add this to the button
    return (
        <Button variant="subtle" pr={"75%"} onClick={handleClick}>{isHighlighted ? (<IconBallpenOff/>) : (<IconBallpen/>)} </Button>
    );
}